import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import './adminLogin.css';
import { useState } from 'react';
import { AuthService } from '../services/authService';
import { FirestoreService } from '../services/firestoreService';
import { HashedDataService } from '../services/hashedDataService/hashedDataService';
import { BrowserRouter as Router, Redirect, Link, Switch, Route } from 'react-router-dom';
import Admin from '../admin/admin.js';
import { useHistory } from "react-router-dom";

function AdminLogin() {
  const history = useHistory();
  const authService = new AuthService(); // nosql database service
  const hashedUserCollection = '/hashedData'; //collection name
  const hashedDataService = new HashedDataService(hashedUserCollection); // nosql database service
  /*********************** Hooks varaiables start here*************************/
  const [email, setEmail] = useState(''); // email hook
  const [password, setPassword] = useState(''); // country code hook
  /************************ Hooks varaiables end here**************************/

  /******************Hooks functions start here********************************/
   const emailChange = (event) => {
      setEmail(event.target.value );
    };// Email hook function
  const passwordChange = (event) => {
    setPassword(event.target.value);
  };

  const loginClick = async () => {
    const result = await authService.adminLogin(email, password);
    // implementation of the getter for hashed user
    const hashedUser = await hashedDataService.getHashedUserData();
    if(result===true){
      console.log(hashedUser[0].hashedUser);
      document.cookie = `user=${hashedUser[0].hashedUser}; max-age=3600; secure`;
      history.push("/admin");
    }
    else {
      console.log(result.message);
    }
   };
   /******************Hooks functions ends here********************************/
  return (
    <Router>

  <span className="AdminLogin">
  <span>
  <h2 className="AdminLogin-Header">Admin Login</h2>
  &nbsp;
  </span>
  <span>
  <TextField
  color="secondary"
  label="E-mail*" type="email" variant="outlined"
  value={email} onChange={emailChange}
  className="AdminLogin-Element"/>
  </span>
  <span>
  <TextField
  color="secondary"
  label="Password*" type="password" variant="outlined"
  value={password} onChange={passwordChange}
  className="AdminLogin-Element"/>
  </span>
  <span>
  <Button variant="outlined"
   onClick={loginClick}
   color="secondary"
   className="AdminLogin-Button">Login</Button>
   </span>
  </span>
  <Switch>
  <Route exact path="/admin" render={() => <Admin />}></Route>
</Switch>
</Router>

  );
}
export default AdminLogin;
